import React from 'react';
import Navbar from './Navbar';
import Contact from './Contact';
import Footer from './Footer';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <Navbar />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;
